import { compact } from '@quromedical/utils';

const mergeErrors = errors => {
  const messages = errors.map(error => error.messages).flat();
  return {
    type: 'error',
    messages
  };
};
/**
 * this function takes in a set of parameters and returns a function that takes in a set of
 * parameters and returns a success or error result. The function is composed of a set of rules
 * that are run in order. The first error result is returned.
 * If no error result is returned, the rule is considered successful.
 * @returns a function that takes in a set of parameters and returns a success or error result
 */


export const compose = composeParams => {
  const {
    assertions,
    defaultAssertions,
    defaultResolver,
    getRuleName,
    resolvers
  } = composeParams;

  const invokeRules = params => {
    const ruleName = getRuleName(params);
    const ruleAssertion = assertions === null || assertions === void 0 ? void 0 : assertions[ruleName];
    const resolvedAssertion = ruleAssertion || defaultAssertions;
    const result = resolvedAssertion.map(assertion => assertion(params));
    const errors = compact(result);
    const hasErrors = errors.length > 0;

    if (hasErrors) {
      return mergeErrors(errors);
    }

    const ruleResolver = resolvers === null || resolvers === void 0 ? void 0 : resolvers[ruleName];
    const resolve = ruleResolver || defaultResolver;
    return resolve(params);
  };

  return invokeRules;
};
/**
 * Create a resolver that will return a `successs` result with the given `value`
 */

export const resolveConstant = value => () => ({
  type: 'success',
  value
});

/**
 * Creates a validator that will resolve errors if the assertions are not met
 * Otherwise will return undefined
 */
export const composeValidator = composeParams => {
  const resolve = compose({ ...composeParams,
    defaultResolver: resolveConstant(true),
    resolvers: {}
  });
  return params => {
    const result = resolve(params);

    if (result.type === 'success') {
      return undefined;
    }

    return result;
  };
};
/**
 * Create a rule that will always return an error result with the provided message
 */

export const assertError = message => () => ({
  type: 'error',
  messages: [message]
});
//# sourceMappingURL=composer.js.map